// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"loaderStyle_mainContainer__1Dl-S","ball":"loaderStyle_ball__2NtNZ"};